import { IInstantPayoutResponse } from "@wingspanhq/payments/dist/interfaces";
import { CreditCardType as CleaveCreditCardType } from "cleave.js/options/creditCard";

export type CreditCardType =
  | "amex"
  | "discover"
  | "diners"
  | "jcb"
  | "mastercard"
  | "unknown"
  | "unionPay"
  | "visa";

export const stripeCardBrandToCreditCardType = (
  brand?: string
): CreditCardType => {
  switch (brand?.toLowerCase()) {
    case "american express":
      return "amex";
    case "diners club":
      return "diners";
    case "discover":
      return "discover";
    case "jcb":
      return "jcb";
    case "mastercard":
      return "mastercard";
    case "unionpay":
      return "unionPay";
    case "visa":
      return "visa";
    case "unknown":
    default:
      return "unknown";
  }
};

export const cleaveCardTypeToCreditCardType = (
  cleaveCardType: CleaveCreditCardType
): CreditCardType => {
  switch (cleaveCardType) {
    case "amex":
    case "discover":
    case "diners":
    case "jcb":
    case "mastercard":
    case "unionPay":
    case "visa":
      return cleaveCardType;
    default:
      return "unknown";
  }
};

export const getInstantPayoutCardName = (
  instantPayout: IInstantPayoutResponse
) => {
  return `${instantPayout.instantPayoutAccount.numbers.brand} Debit${
    instantPayout.instantPayoutAccount.numbers.last4
      ? ` (${instantPayout.instantPayoutAccount.numbers.last4})`
      : ""
  }`;
};
